export default __webpack_public_path__ + "0d13adf39ac1c52b2723803f38ce90fb.png";